import { render } from "./marktersAdd.vue?vue&type=template&id=8affc284&scoped=true"
import script from "./marktersAdd.vue?vue&type=script&lang=js"
export * from "./marktersAdd.vue?vue&type=script&lang=js"

import "./marktersAdd.vue?vue&type=style&index=0&id=8affc284&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8affc284"]])

export default __exports__